import React from "react"
import i18n from "i18n"
import {
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
} from "@mui/material"
import Collapsable from "common/Collapsable"
import { useMarginsDiscounts } from "hooks/margin/useMarginsDiscounts"

export const CLIENT = "CLIENT"
export const COST = "COST"
export const NOT_SET = "NOT_SET"

const FormulasTab = () => {
  const { state, setIsClientPrice } = useMarginsDiscounts()

  const handleChange = event => {
    setIsClientPrice(event.target.value === CLIENT)
  }

  return (
    <Grid container spacing={2}>
      <Grid container item spacing={2}>
        <Grid item xs={12}>
          <Collapsable expanded title={i18n.t("formulasTab.title")}>
            <Grid container item spacing={2}>
              <Grid container item spacing={2}>
                <Grid item xs={12}>
                  <FormControl>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      name="radio-buttons-group"
                      value={state.formulas.isClientPrice ? CLIENT : COST}
                      onChange={handleChange}
                    >
                      <FormControlLabel
                        value={COST}
                        control={<Radio />}
                        label={i18n.t("formulasTab.cost")}
                      />
                      <FormControlLabel
                        value={CLIENT}
                        control={<Radio />}
                        label={i18n.t("formulasTab.client")}
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
          </Collapsable>
        </Grid>
      </Grid>
    </Grid>
  )
}

FormulasTab.propTypes = {}

export default FormulasTab
